jQuery($ => {
  class CaseStudiesBlock {
    constructor(element) {
      this._ = element;
      this._element = $(element);
      this._list = this._element.find('.m-case-studies__list');
      this._loader = this._element.find('.o-case-studies-block__loader');

      this.init();
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Initialize
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    init() {
      this.setupHandlers();
      this._element.trigger('init', this);
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Setup Handlers
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    setupHandlers() {
      $(document).on('click', '[data-case-studies-load-more]', (e) => this.loadMore(e));
    }

    loadMore = (e) => {
      console.log('clicked');
      e.preventDefault();

      const $button = $(e.currentTarget);

      if (!this._element.length || typeof CASE_STUDIES_AJAX == 'undefined') return;

      const paged = parseInt(this._element.data('paged'), 10) || 1;
      const maxPages = parseInt(this._element.data('max-pages'), 10) || 1;
      const nextPage = paged + 1;

      if (paged >= maxPages) {
        $button.remove();
        return;
      }

      if (!this._list.length) return;

      $.ajax({
        url: CASE_STUDIES_AJAX.url,
        type: 'POST',
        data: {
          action: 'get_case_studies',
          nonce: CASE_STUDIES_AJAX.nonce,
          paged: nextPage
        },
        beforeSend: () => {
          $button.prop('disabled', true);
          this._loader.show();
        },
        success: (response) => {
          if (response.success && response.data) {
            this._list.append(response.data.html);
            this._element.data('paged', nextPage);

            const updatedMaxPages = parseInt(response.data.max_num_pages, 10);

            if (Number.isFinite(updatedMaxPages)) {
              this._element.data('max-pages', updatedMaxPages);
            }

            if (nextPage >= updatedMaxPages) {
              $button.remove();
            }
          }
        },
        complete: () => {
          $button.prop('disabled', false);
          this._loader.hide();
        }
      })
    }
  }

  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  // ✅ Setup jQuery Plugin
  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

  $.fn.case_studies_block = function () {
    var _ = this,
      opt = arguments[0],
      args = Array.prototype.slice.call(arguments, 1),
      l = _.length,
      i,
      ret;
    for (i = 0; i < l; i++) {
      if (typeof opt == 'object' || typeof opt == 'undefined')
        _[i].case_studies_block = new CaseStudiesBlock(_[i], opt);
      else
        ret = _[i].case_studies_block[opt].apply(_[i].case_studies_block, args);
      if (typeof ret != 'undefined') return ret;
    }
    return _;
  }

  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  // ✅ Run
  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

  $('.o-case-studies-block').case_studies_block();
});